import axios, { setAuthorization, removeAuthorization, handleResp } from "../config/axios";
import { removeAuthToken, setAuthToken } from "../lib/localStorage";
import { setAccountData } from "./userlogin";
import { clearRecentGamesFromStorage } from "../../utility/favoritesRecents";

import {
    REMOVE_AUTHENTICATION,   
  } from "../constants";


export const logout = (history, dispatch) => {
    try {
        removeAuthToken();
        clearRecentGamesFromStorage();
        removeAuthorization();
        dispatch({
            type: REMOVE_AUTHENTICATION,
            authData: {
                isAuth: false,
            },
        });
        dispatch(setAccountData({
            _id: "",
            firstName: "",
            lastName: "",
            emailId: "",
            dateOfBirth: "",
            password: "",
            profile: "",
            google2Fa: null,
        }));
        history.push("/login");
    } catch (err) {
        console.log(err, 'logout')
    }
};